// Libraries
import React, { FC, useCallback, useState } from 'react';
import { Avatar, Container, Typography } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useTranslation } from 'react-i18next';

// Components
import SimpleModal from '../Modals/SimpleModal';
import { setActivationModalOpen } from '../../redux/reducers/ui/modalsReducer';
import { useAppDispatch } from '../../hooks/redux';
import ResendActivationButton from './ResendActivationButton';

const ActivationModal: FC = () => {
	const dispatch = useAppDispatch();
	const { t } = useTranslation();
	const [isResendOpen, setIsResendOpen] = useState<boolean>(false);

	const handleClose = useCallback(() => {
		dispatch(setActivationModalOpen(false));
	}, [dispatch]);
	const openResendOption = (e: React.MouseEvent<HTMLElement>) => {
		e.preventDefault();
		setIsResendOpen(true);
	};

	const content: React.ReactElement = (
		<Container component="main" maxWidth="xs">
			<div className="AuthModal__wrapper">
				<div className="AuthModal__title">
					<Avatar className="AuthModal__avatar success">
						<VerifiedIcon />
					</Avatar>
					<Typography
						component="h1"
						variant="h6"
						style={{ textAlign: 'center', marginTop: '10px' }}
					>
						{t('verificationMessageTitle')}
					</Typography>
					<Typography
						component="p"
						variant="body1"
						sx={{ textAlign: 'center', marginTop: '10px' }}
					>
						{t('verificationMessageBody')}
					</Typography>
				</div>
				<div style={{ textAlign: 'center', marginTop: '10px' }}>
					{!isResendOpen && (
						<div className="AuthModal__extra-options">
							<a href="openResendOption" onClick={(e) => openResendOption(e)}>
								{t('resendVerificationQuestion')}
							</a>
						</div>
					)}
					{isResendOpen && (
						<>
							<Typography component="p" variant="body1">
								{t('resendVerificationMessage')}
							</Typography>
							<ResendActivationButton />
						</>
					)}
				</div>
			</div>
		</Container>
	);

	return (
		<SimpleModal isOpen handleClose={handleClose} content={content} hideActions />
	);
};

export default ActivationModal;
